import { activityHistoryCollectionsSlice } from "../slice";

export const { clearActivityHistoryCollections } = activityHistoryCollectionsSlice.actions;
